import axios from "axios";

const instance = axios.create({
  timeout: 10000,
  headers: {
    "Content-Type": "application/json;charset=utf-8"
  }
});

export default {
  lang(data) {
    return axios.post("wechat/lang", data);
  },
  history() {
    return axios.post("wechat/history");
  },
  thistory() {
    return axios.post("wechat/thistory");
  },
  access() {
    return axios.post("wechat/access");
  },
  record() {
    return axios.post("wechat/record");
  },
  region() {
    return axios.post("wechat/region");
  },
  approval(id, status, cause) {
    return axios.post("wechat/approval", {
      id: id,
      status: status,
      cause: cause
    });
  },
  num(id, num) {
    return axios.post("wechat/num", {
      id: id,
      num: num
    });
  },
  invite(data) {
    return axios.post("wechat/invite", data);
  },
  ticket(data) {
    return axios.post("wechat/ticket", data);
  },
  getRecord(data) {
    return axios.post("wechat/getRecord", data);
  },
  signIn(data) {
    return axios.post("admin/signIn", data);
  },
  staff() {
    return axios.post("admin/staff");
  },

  getRegion() {
    return axios.post("admin/region");
  },
  getInvite(data) {
    return axios.post("admin/invite", data);
  },
  getArrive(data) {
    return axios.post("admin/arrive", data);
  },
  staffData() {
    return axios.post("server/sync");
  },
  menuData() {
    return axios.post("server/menu");
  },
  changePassword(data) {
    return axios.post("admin/changePassword", data);
  },
  searchStaff(data) {
    return axios.post("admin/searchStaff", data);
  },
  getSystem() {
    return axios.post("admin/getSystem");
  },
  changeSystem(data) {
    return axios.post("admin/changeSystem", data);
  },
  deleteRegion(data) {
    return axios.post("admin/deleteRegion", data);
  },
  getPort() {
    return axios.post("admin/getPort");
  },
  createRegion(data) {
    return axios.post("admin/createRegion", data);
  },
  updateRegion(data) {
    return axios.post("admin/updateRegion", data);
  },
  searchInvite(data) {
    return axios.post("admin/searchInvite", data);
  },

  createStaff(data) {
    //单个添加被访人信息
    return axios.post("admin/createStaff", data);
  },
  deleteStaff(data) {
    //单个删除被访人信息
    return axios.post("admin/deleteStaff", data);
  },
  updateStaff(data) {
    //单个删除修改被访人信息
    return axios.post("admin/updateStaff", data);
  },
  getDepartment(data) {
    // 获取部门信息
    return axios.post("admin/getDepartment", data);
  },
  createDepartment(data) {
    //添加部门信息
    return axios.post("admin/createDepartment", data);
  },
  deleteDepartment(data) {
    //删除部门信息
    return axios.post("admin/deleteDepartment", data);
  },
  updateDepartment(data) {
    //删除修改部门信息
    return axios.post("admin/updateDepartment", data);
  },
  getReasons() {
    // 获取来访事由
    return axios.post("wechat/getReasons");
  },
  getTruckType() {
    //
    return axios.post("wechat/getTruckType");
  },
  getTruckReason() {
    //
    return axios.post("wechat/getTruckReason");
  },
  getVisitorType() {
    // 获取来访类型
    return axios.post("wechat/getVisitorType");
  },
  createReasons(data) {
    //添加来访事由
    return axios.post("admin/createReasons", data);
  },
  deleteReasons(data) {
    //删除来访事由
    return axios.post("admin/deleteReasons", data);
  },
  updateReasons(data) {
    //删除修改来访事由
    return axios.post("admin/updateReasons", data);
  },
  searchReserve(data) {
    //查找访客预约记录
    return axios.post("admin/searchReserve", data);
  },
  deleteRecord(data) {
    //删除预约记录
    return axios.post("admin/deleteRecord", data);
  },

  vpersonal(data) {
    //提交访客信息
    return axios.post("wechat/vpersonal", data);
  },
  getVisitorInfo() {
    //获取访客信息
    return axios.post("wechat/getVisitorInfo");
  },
  getStaffName(data) {
    //获取被访人姓名
    return axios.post("wechat/getStaffName", data);
  },
  // getReasons(data) {//获取来访事由
  //     return axios.post('wechat/getReasons', data);
  // },
  vreserve(data) {
    //发起预约
    return axios.post("wechat/vreserve", data);
  },
  treserve(data) {
    //发起预约
    return axios.post("wechat/treserve", data);
  },

  tpersonal(data) {
    //
    return axios.post("wechat/tpersonal", data);
  },
  getUserInfo() {
    //获取访客信息
    return axios.post("wechat/getUserInfo");
  },
  getruckInfo() {
    //
    return axios.post("wechat/getruckInfo");
  },

  tinvite(data) {
    //
    return axios.post("wechat/tinvite", data);
  },

  getTicket(data) {
    //获取微信公众号Ticket
    return axios.post("wechat/getTicket", data);
  },
  getCorpTicket(data) {
    //获取企业微信Ticket
    return axios.post("wechat/getCorpTicket", data);
  },
  getSVecord(data) {
    //访客获取模板消息的记录
    return axios.post("wechat/getSVecord", data);
  },

  getStaffInfo() {
    //获取被访人信息
    return axios.post("wechat/getStaffInfo");
  },
  spersonal(data) {
    //被访人员绑定信息
    return axios.post("wechat/spersonal", data);
  },
  disSpersonal(data) {
    //被访人员解除绑定
    return axios.post("wechat/disSpersonal", data);
  },
  getCode(data) {
    //被访人员获取短信验证码
    return axios.post("wechat/getCode", data);
  },
  staffRefuse(data) {
    //被访人员拒绝来访
    return axios.post("wechat/staffRefuse", data);
  },
  staffAgree(data) {
    //被访人员同意来访
    return axios.post("wechat/staffAgree", data);
  },

  staffTRefuse(data) {
    //
    return axios.post("wechat/staffTRefuse", data);
  },
  staffTAgree(data) {
    //
    return axios.post("wechat/staffTAgree", data);
  },

  leaderRefuse(data) {
    //领导拒绝来访
    return axios.post("wechat/leaderRefuse", data);
  },
  leaderAgree(data) {
    //领导同意来访
    return axios.post("wechat/leaderAgree", data);
  },
  // 三级审批
  cameraLeaderRefuse(data) {
    //拒绝来访
    return axios.post("wechat/cameraLeaderRefuse", data);
  },
  cameraLeaderAgree(data) {
    //三级审批 同意
    return axios.post("wechat/cameraLeaderAgree", data);
  },

  leaderAgreeAll(data) {
    //领导同意来访
    return axios.post("wechat/leaderAgreeAll", data);
  },
  getSRecord(data) {
    //被访人员获取模板消息的记录
    return axios.post("wechat/getSRecord", data);
  },
  getSTRecord(data) {
    //被访人员获取模板消息的记录
    return axios.post("wechat/getSTRecord", data);
  },
  getSTRecord(data) {
    //
    return axios.post("wechat/getSTRecord", data);
  },
  getLRecord(data) {
    //部门领导获取模板消息的记录
    return axios.post("wechat/getLRecord", data);
  },
  getVRecord(data) {
    //访客获取模板消息的记录
    return axios.post("wechat/getVRecord", data);
  },
  getCRecord(data) {
    //抄送人获取模板消息的记录
    return axios.post("wechat/getCRecord", data);
  },
  getStaffRecord(data) {
    //获取员工的预约、邀请记录
    return axios.post("wechat/getStaffRecord", data);
  },
  getVisitorRecord() {
    //获取访客预约记录
    return axios.post("wechat/getVisitorRecord");
  },
  searchLeaderLst(data) {
    // 查找审批人
    return axios.post("wechat/searchLeaderLst", data);
  },
  // 放行条
  getItemType(data) {
    // 获取物品类型
    return axios.post("wechat/getItemType", data);
  },
  getReleaseReason(data) {
    // 获取放行原因
    return axios.post("wechat/getReleaseReason", data);
  },
  createRelease(data) {
    // 发起请假申请
    return axios.post("wechat/createRelease", data);
  },
  getReleaseRecord(data) {
    // 获取放行条记录列表
    return axios.post("wechat/getReleaseRecord", data);
  },
  getReleaseRecordLeader(data) {
    //
    return axios.post("wechat/getReleaseRecordLeader", data);
  },
  getReleaseRecordDetail(data) {
    // 获取放行条记录详细信息
    return axios.post("wechat/getReleaseRecordDetail", data);
  },
  getReleaseRecordReturn(data) {
    //
    return axios.post("wechat/getReleaseRecordReturn", data);
  },
  leaderAgreeRelease(data) {
    // 同意放行条申请
    return axios.post("wechat/leaderAgreeRelease", data);
  },
  leaderRefuseRelease(data) {
    // 拒绝放行条申请
    return axios.post("wechat/leaderRefuseRelease", data);
  },
  searchReleaseLeaderLst(data) {
    // 查找放行条审批人
    return axios.post("wechat/searchReleaseLeaderLst", data);
  },
  getReleaseRecordToday(data) {
    // 获取放行条记录列表-当天
    return axios.post("wechat/getReleaseRecordToday", data);
  },
  getReleaseRecordDetailToday(data) {
    // 获取放行条记录详细信息-当天
    return axios.post("wechat/getReleaseRecordDetailToday", data);
  },
  getTruckRecord(data) {
    // -当天
    return axios.post("wechat/getTruckRecord", data);
  },
  getTruckRecordToday(data) {
    // -当天
    return axios.post("wechat/getTruckRecordToday", data);
  },
  getTruckRecordDetailToday(data) {
    // -当天
    return axios.post("wechat/getTruckRecordDetailToday", data);
  },
  securityAgreeRelease(data) {
    // 保安确定放行放行条申请
    return axios.post("wechat/securityAgreeRelease", data);
  },
  securityRefuseRelease(data) {
    // 保安拒绝放行
    return axios.post("wechat/securityRefuseRelease", data);
  },

  securityAgreeTruck(data) {
    //
    return axios.post("wechat/securityAgreeTruck", data);
  },
  securityRefuseTruck(data) {
    //
    return axios.post("wechat/securityRefuseTruck", data);
  },

  securityAgreeReturn(data) {
    // 保安确定物品返回
    return axios.post("wechat/securityAgreeReturn", data);
  },

  addBuChong(data) {
    //
    return axios.post("wechat/addBuChong", data);
  },

  getCorpLst(data) {
    // 获取企业列表
    return axios.post("wechat/getCorpLst", data);
  },

  uploadImages(data) {
    // 把微信公众号的临时照片存储到本地，并反馈照片是人脸是人脸照片是否符合初期的入库标准
    return axios.post("wechat/uploadImages", data);
  },

  getScores(data) {
    //获取分数
    return axios.post("KaoShi/getScores", data);
  },
  getKaoShi(data) {
    //获取考试试题
    return axios.post("KaoShi/getKaoShi", data);
  },
  submitdati(data) {
    //
    return axios.post("KaoShi/submitdati", data);
  },
  getIdCardInfomation(data) {
    //
    return axios.post("KaoShi/getIdCardInfomation", data);
  },

  getReleaseRecordStaffReturn(data) {
    // 员工查看自己有哪些物品还没有返回
    return axios.post("wechat/getReleaseRecordStaffReturn", data);
  },
  getReleaseRecordDetailStaffReturn(data) {
    // 员工查看物品返回记录详情
    return axios.post("wechat/getReleaseRecordDetailStaffReturn", data);
  },
  staffAgreeReturn(data) {
    // 员工最终确定物品返回
    return axios.post("wechat/staffAgreeReturn", data);
  },
  changeReturnTime(data) {
    // 修改物品返回时间
    return axios.post("wechat/changeReturnTime", data);
  },
  leaderAgreeReturnTime(data) {
    // 同意修改返回时间
    return axios.post("wechat/leaderAgreeReturnTime", data);
  },
  leaderRefuseReturnTime(data) {
    // 拒绝修改返回时间
    return axios.post("wechat/leaderRefuseReturnTime", data);
  }
};



// WEBPACK FOOTER //
// ./src/http.js